var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LadResizer',{attrs:{"container-class":"lad-reviews","max-sm-width":540,"max-xs-width":420}},[(_vm.isProduct)?_c('LadReviewsProduct',{attrs:{"uuid":_vm.uuid}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }